import Phaser from "phaser";
import { Colors } from "../consts/Colors";
import ButtonRounded from "../prefabs/ButtonRounded.js";

export default class WhiteRoundedRectangle extends Phaser.GameObjects
  .Container {
  constructor(
    scene,
    x,
    y,
    width,
    height,
    text,
    buttonOptions = null,
    buttonTxt = null,
    titreOptions = null,
    titreTxt = null
  ) {
    super(scene, x, y);

    // Rounded rectangle
    const radius = 20;
    const rect = scene.add.graphics();
    rect.fillStyle(0xffffff, 1);
    rect.fillRoundedRect(0, 0, width, height, radius);

    this.add(rect);

    // Centered text
    const txt = scene.add.text(width / 2, height / 2, text, {
      color: Colors.Text.DarkBlue,
      fontSize: `${20 * 1.5}px`,
      fontFamily: "Binx",
      align: "center",
      wordWrap: { width: width - 40 },
    });
    txt.setOrigin(0.5);
    this.add(txt);

    if (titreOptions) {
      const titre = scene.add.text(width / 2, 20 + 45, titreTxt || "Titre", {
        color: Colors.Text.BleuNovotel,
        fontSize: `${32 * 1.5}px`,
        fontFamily: "Binx",
        align: "center",
      });
      titre.setOrigin(0.5);
      this.add(titre);
    }

    // Optional button
    if (buttonOptions) {
      const btnWidth = width * 0.6;
      const btnHeight = 40;
      const btnY = height - btnHeight - 20;

      this.btn = scene.add.existing(
        new ButtonRounded(
          scene,
          width / 2,
          btnY,
          btnWidth,
          btnHeight,
          buttonTxt || "OK",
          Colors.Text.White,
          Colors.Elmt.BleuNovotel,
          false,
          Colors.Text.White,
          true,
          false,
          "arrow-right-white",
          null
        )
      );

      this.add(this.btn);
    }

    this.setSize(width, height);
    scene.add.existing(this);
  }
}
